function coerceUnitPriceForApi(p) {
  const raw =
    p?.price ??
    p?.itemPrice ??
    p?.item_price ??
    p?.unitPrice ??
    p?.unit_price ??
    p?.discountedPrice ??
    p?.discounted_unit_price ??
    p?.discountedUnitPrice;
  if (raw == null || raw === "") return undefined;
  const n =
    typeof raw === "string"
      ? parseFloat(String(raw).replace(/[^0-9.-]/g, ""))
      : Number(raw);
  return Number.isFinite(n) ? n : undefined;
}

function unitPriceForSubscriptionLine(p) {
  return coerceUnitPriceForApi(p) ?? 0;
}

export function coerceVariantIdForApi(v) {
  if (v == null || v === "") return "";
  const s = String(v).trim();
  const m = s.match(/ProductVariant\/(\d+)/i);
  if (m) return m[1];
  if (/^\d+$/.test(s)) return s;
  const digits = s.replace(/\D/g, "");
  return digits || s;
}

/**
 * Build payload for POST /updateSubscriptionLineItems (same as allure_account-new).
 */
export function buildSubscriptionOrderLinesFromDclubBundle({
  duplinPicks = [],
  quantities = {},
  bundleItems = [],
  addons = [],
  extraDuplinFromOrder = [],
  /** When true (hydrated from latestSubscriptionOrder), omit Duplin lines with quantity 0. */
  explicitDuplinQuantities = false,
}) {
  const lines = [];
  for (const p of duplinPicks) {
    const vid = coerceVariantIdForApi(p?.variantId ?? p?.id);
    if (!vid) continue;
    const raw = quantities[p.id];
    const qty = explicitDuplinQuantities
      ? Math.max(0, Number(raw) || 0)
      : Math.max(1, Number(raw) || 1);
    if (qty < 1) continue;
    lines.push({
      variantId: vid,
      quantity: qty,
      lineType: "duplin_pick",
      price: unitPriceForSubscriptionLine(p),
    });
  }
  for (const p of extraDuplinFromOrder) {
    const vid = coerceVariantIdForApi(p?.variantId ?? p?.id);
    if (!vid) continue;
    const qty = Math.max(1, Number(p.quantity) || 1);
    lines.push({
      variantId: vid,
      quantity: qty,
      lineType: "duplin_pick",
      price: unitPriceForSubscriptionLine(p),
    });
  }
  for (const p of bundleItems) {
    const vid = coerceVariantIdForApi(p?.variantId ?? p?.id);
    if (!vid) continue;
    lines.push({
      variantId: vid,
      quantity: 1,
      lineType: "your_pick",
      price: unitPriceForSubscriptionLine(p),
    });
  }
  for (const p of addons) {
    const vid = coerceVariantIdForApi(p?.variantId ?? p?.id);
    if (!vid) continue;
    lines.push({
      variantId: vid,
      quantity: 1,
      lineType: "add_on",
      price: unitPriceForSubscriptionLine(p),
    });
  }
  return lines;
}
